export const ENVIRONMENT = 'stage';
export const DOMAIN = 'stage.streambank.com';
export const SBM_VERSION = '2.3.4 (July 15, 2026)';
export const TOS_LAST_UPDATED = '2025-08-01';

//keyboard values
export const SB_ENTER_KEY_CODE = 13;
export const SB_ESC_KEY_CODE = 27;